export default __webpack_public_path__ + "static/data-product-data-mesh-architettura-dati-scalabile-governata-2e0321d8e99dea52ce03ec44dad6a10d.jpg";